'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MixpanelContext = require('./MixpanelContext');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MixpanelContext).default;
  }
});
Object.defineProperty(exports, 'MixpanelProvider', {
  enumerable: true,
  get: function get() {
    return _MixpanelContext.MixpanelProvider;
  }
});
Object.defineProperty(exports, 'MixpanelConsumer', {
  enumerable: true,
  get: function get() {
    return _MixpanelContext.MixpanelConsumer;
  }
});
Object.defineProperty(exports, 'mixpanelShape', {
  enumerable: true,
  get: function get() {
    return _MixpanelContext.mixpanelShape;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }